// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('selectReport', {
//         templateUrl: 'views/components/views/selectReport/selectReport.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'dbReportService', function ($stateParams, dbReportService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let webPageName = $stateParams.webpage_name;
//             let argType = $stateParams.argtype;
//             let argValue = $stateParams.argvalue;
            
//             vm.model = {
//                 itemsListReports: []
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE FUNCTION CALL

//             async function loadReports() {
//                 vm.model.itemsListReports = await dbReportService.loadReports(webPageName, argType, argValue);
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALL

//             // #region ON INIT FUNCTION

//             vm.$onInit = function () {
//                 loadReports();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
